import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  lobbyTable: {
    borderRadius: theme.radius.md,

    'thead tr th': {
      padding: /* eslint-disable-line local-rules/use-theme-tokens */ '12px 0',
    },

    'tbody tr td': {
      padding: /* eslint-disable-line local-rules/use-theme-tokens */ '8px 16px 8px 0',
    },
  },
}));

export default useStyles;
